import UICreatorGraphics from "@baseUI/utils/UICreatorGraphics";
import UICreatorComponent from "@baseUI/utils/UICreatorComponent";
import UICreatorText from "@baseUI/utils/UICreatorText";
import SettingsPartContainer from "@baseUI/component/settings/SettingsPartContainer";

export default class SettingsSettingsPartContainer extends SettingsPartContainer {

    constructor(params) {
        super(params)
        this.setParametersSizePosition(params)
        this.init()
    }

    setParametersSizePosition(params){
        this.param = {
            panelPopupPosition: {x: 0, y: 0},
            popupSettingsCaptionPosition: [550, 0],
            lineTop: {x1: -100, y1: 100, x2: 1300, y2: 100 },
            lineMiddle: {x1: -100, y1: 500, x2: 1300, y2: 500 },
            musicTextPosition: [150, 210],
            soundsTextPosition: [150, 360],
            spaceTextPosition: [150, 650],
            musicStatePosition: [800, 240],
            soundsStatePosition: [800, 390],
            spaceStatePosition: [800, 680]
       }
    }

    init() {

        const panelPopup = UICreatorComponent.addContainer(this, this.param.panelPopupPosition)
        const lineTop = this.param.lineTop
        UICreatorGraphics.addLine(panelPopup, lineTop.x1, lineTop.y1, lineTop.x2, lineTop.y2)

        UICreatorText.addElementTextName('popupSettingsCaption_TEXT', panelPopup, this.param.popupSettingsCaptionPosition)
        UICreatorText.addElementTextName('popupSettingsMusic_TEXT', panelPopup, this.param.musicTextPosition, 0)
        UICreatorText.addElementTextName('popupSettingsSounds_TEXT', panelPopup,  this.param.soundsTextPosition, 0)
        this.spaceText = UICreatorText.addElementTextName('popupSettingsSpace_TEXT', panelPopup, this.param.spaceTextPosition, 0)

        const lineMiddle = this.param.lineMiddle
        UICreatorGraphics.addLine(panelPopup, lineMiddle.x1, lineMiddle.y1, lineMiddle.x2, lineMiddle.y2)

        UICreatorComponent.addListenerStateButton('settingsMusic_STATE', 'settingsMusic',panelPopup, this.param.musicStatePosition)
        UICreatorComponent.addListenerStateButton('settingsSounds_STATE', 'settingsSounds',panelPopup, this.param.soundsStatePosition)
        this.spaceState = UICreatorComponent.addListenerStateButton('settingsSpace_STATE', 'settingsSpace',panelPopup, this.param.spaceStatePosition)
    }

}